// extracted by mini-css-extract-plugin
module.exports = {"OrderPage":"styles_OrderPage__zGKd9"};